// eslint-disable-next-line import/prefer-default-export
export const UPDATE_ALL_SUBSCRIPTIONS = 'UPDATE_ALL_SUBSCRIPTIONS';
export const UPDATE_ALL_FAILED_SUBSCRIPTIONS = 'UPDATE_ALL_FAILED_SUBSCRIPTIONS';
